<template>
  <div class="appeal-page">
    <div class="top">
      <span class="title">我要申诉</span>
      <img src="@/assets/images/person/appeal-page-top-icon.png" alt="" class="top-icon">
    </div>
    <div class="content-box">
      <div>
        <div class="form-item flex" v-if="userInfo.memberType === 0">
          <div class="form-label required">所在医院</div>
          <div class="form-content">
            <div class="div-input" @click="handleClickHos('click')">
              <input
                type="text"
                class="input-txt"
                placeholder="请选择医院"
                v-model="paramsData.hospitalName"
                readonly
              />
              <img src="@/assets/images/regist/img4.png" class="icon-arrow" alt=""/>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label required">申诉内容</div>
          <div class="form-content">
            <textarea placeholder="请输入申诉内容" v-model="paramsData.appealContent" rows="5"
                      class="textarea" maxlength="200"></textarea>
          </div>
          <div class="tip">
            最多200字
          </div>
        </div>
        <div class="form-item">
          <div class="form-label required">图片上传</div>
          <div class="form-content">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="10"
              :after-read="afterRead"
              :before-delete="beforeDelete"
              :upload-icon="uploadIcon"
            >
              <div class="upload-box" v-if="!fileList.length">
                <img src="@/assets/images/home/upload-icon2.png" alt="" class="upload-icon">
              </div>
            </van-uploader>
          </div>
          <div class="tip">
            {{
              userInfo.memberType === 0 ? '请提供能证明您在职的图片，如医院挂号界面，医院官网介绍，工牌，照片墙等，谢谢' : '请提供能证明您在职的信息，公司内部WWID+姓名。'
            }}
          </div>
          <div class="tip1">
            {{
              '若您的照片有肖像，请您将肖像遮挡后再上传，谢谢'
            }}
          </div>
        </div>
        <div class="button-group">
          <van-button class="confirm-btn" v-track="{ functionName: '申诉页-提交' }" @click.stop="confirm">提交
          </van-button>
        </div>
      </div>
    </div>
    <div class="dailog-div" v-if="isHos">
      <div class="dialog-bg"></div>
      <div class="dialog-cons" :class="{ search: true }">
        <div class="cons-title">
          <span class="cancel-btn" @click="handleClose">取消</span>
          <span class="title-txt">请选择医院</span>
          <span class="confirm-btn"></span>
        </div>
        <div class="cons-search-hos">
          <div class="search-hos-div">
            <input
              type="search"
              class="input-search"
              placeholder="请输入医院名称"
              v-model="hospitalSearch"
              @keydown.enter.prevent="handleClickHos('search')"
            />
            <div class="border-btn" @click.stop="handleClickHos('search')">
              <img src="../../assets/images/home/img4.png" class="icon-search" alt="">
              <span class="btn-txt">搜索</span>
            </div>
          </div>
          <div class="search-hos-list">
            <div
              class="search-hos-item"
              v-for="(item, index) in hospitalList"
              :key="index"
              @click="handleClickHosItem(item)"
            >
              <div class="item-name">{{ item && item.cnName }}</div>
              <div class="item-addr">{{ item && item.address }}</div>
            </div>
            <div class="search-more" v-if="!isLoad" @click="handleClickMoreHos">
              加载更多...
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadIcon from '@/assets/images/home/upload-icon.png'
import wx from 'weixin-js-sdk'
import {getUserIdentity, redirectToWxAuth} from '../../utils/util'
import {appealRecord, sysFiles, uploadFile} from '../../api/api'
import {getHospitalList} from '../../api/register'

export default {
  data() {
    return {
      fileList: [],
      uploadIcon,
      userIdentity: getUserIdentity(),
      paramsData: {
        id: '',
        userId: '',
        openId: '',
        module: 1,
        appealContent: '',
        hospitalId: '',
        hospitalName: '',
      },
      hospitalList: [],
      isLoad: false,
      pageNum: 1,
      hospitalSearch: '',
      isHos: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  async created() {
    const res = await sysFiles()
    this.paramsData.id = res.data
    this.paramsData.userId = this.userInfo.id
    this.paramsData.openId = this.userInfo.iepOpenId
    this.paramsData.hospitalId = this.userInfo.hospitalId
    this.paramsData.hospitalName = this.userInfo.hospitalName
  },
  methods: {
    handleClose() {
      this.isHos = false
    },
    handleClickMoreHos() {
      this.pageNum++
      this.handleClickHos()
    },
    handleClickHosItem(item) {
      this.paramsData.hospitalName = item.cnName
      this.paramsData.hospitalId = item.id
      this.isHos = false
    },
    handleClickHos(type) {
      if (type === 'click') {
        this.hospitalSearch = this.userInfo.hospitalName
      }
      if (type === 'search' || type === 'click') {
        this.pageNum = 1
        this.isLoad = false
        this.hospitalList = []
      }
      let params = {
        name: this.hospitalSearch,
        pageNum: this.pageNum,
        hpCusttypeCd: 1,
        custTypeCdIn: 1,
      }
      getHospitalList(params)
        .then((res) => {
          if (res.data.total <= 0) {
            this.$toast('暂无数据, 请联系管理员！')
            return
          }
          if (res.data.list && res.data.list.length > 0) {
            this.hospitalList = this.hospitalList.concat(res.data.list)
          }
          if (`${this.hospitalList.length}` === `${res.data.total}`) {
            this.isLoad = true
          }
        })
        .catch((err) => {
          console.error(err)
        })
      this.isHos = true
    },
    // 文件读取完成后的回调
    async afterRead(file) {
      const files = Array.isArray(file) ? file : [file]

      // 初始化所有文件状态为上传中
      files.forEach(item => {
        item.status = 'uploading'
        item.message = '上传中...'
      })

      // 创建所有上传Promise
      const uploadPromises = files.map(item => this.uploadSingleFile(item))

      // 并行执行所有上传
      try {
        await Promise.all(uploadPromises)
      } catch (error) {
        console.error('部分文件上传失败:', error)
      }
    },

    // 单个文件上传方法
    async uploadSingleFile(item) {
      try {
        // 调用上传接口
        const response = await this.uploadFile(item.file)

        // 上传成功 - 直接修改item属性
        item.status = 'done'
        item.message = '上传成功'
        item.url = response.url
        item.fileId = response.fileId
      } catch (error) {
        // 上传失败 - 直接修改item属性
        item.status = 'failed'
        item.message = '上传失败'
        console.error(`文件上传失败:`, error)
      }
    },

    // 模拟文件上传接口
    async uploadFile(file) {
      let formData = new FormData()
      formData.append('file', file)
      try {
        const res = await uploadFile(this.paramsData.id, formData)
        if (res.code === 0) {
          return {
            id: res.data.id,
            url: res.data.url
          }
        }
        throw new Error('上传失败')
      } catch (e) {
        throw new Error('上传失败')
      }
    },

    // 删除文件前的回调
    beforeDelete(file, detail) {
      return this.$dialog.confirm({
        title: '提示',
        message: '确定要删除该图片吗？'
      })
    },

    async confirm() {
      if (this.userInfo.memberType === 0) {
        if (!this.paramsData.hospitalId) {
          this.$toast('请选择医院')
          return
        }
      }
      if (!this.fileList.length) {
        this.$toast('请上传图片')
        return
      }
      if (!this.paramsData.appealContent.length) {
        this.$toast('请输入申诉内容')
        return
      }
      if (this.paramsData.appealContent.length > 200) {
        this.$toast('申诉内容不能超过200字')
        return
      }
      try {
        const res = await appealRecord(this.paramsData)
        if (res.code === 0) {
          if (!this.userIdentity.isDueDate) {
            this.$toast('申诉提交完毕, 请等待审核!')
            sessionStorage.removeItem('iepLoginResult')
            setTimeout(() => {
              // 前端直接跳转微信授权
              redirectToWxAuth()
            }, 1000)
          } else {
            this.$toast('申诉提交完毕, 请等待审核!')
            setTimeout(() => {
              wx.ready(function () {
                wx.closeWindow()
              })
            }, 1000)
          }
        }
      } catch (e) {
        this.$toast(e.message)
      }
    },
  }
}
</script>

<style scoped lang="less">
.appeal-page {
  width: 100%;
  background: #F9F8F7;
  box-sizing: border-box;

  .top {
    height: 84px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    position: relative;

    .title {
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
    }

    .top-icon {
      width: 84px;
      position: absolute;
      right: 55px;
      top: 20px;
      z-index: 1;
    }
  }

  .content-box {
    padding: 0 16px 30px;
    position: relative;
    z-index: 2;

    & > div {
      background: #FFFFFF;
      border-radius: 10px;
      padding: 24px 12px;
      box-sizing: border-box;
      min-height: calc(100vh - 110px);

      .form-item {

        &.flex {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .form-content {
            flex: 1;
            margin-top: 0;
            margin-left: 10px;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            & > div {
              display: flex;
              align-items: center;
              width: 100%;
            }

            .icon-arrow {
              width: 6px;
              display: block;
              margin-left: 5px;
              height: auto;
            }

            .input-txt {
              font-family: PingFang HK, PingFang HK;
              font-size: 14px;
              color: #000000;
              border: none;
              outline: none;
              background-color: transparent;
              height: 100%;
              text-align: right;
              flex: 1;
              min-width: 1px;
            }
          }
        }

        & + .form-item {
          margin-top: 20px;
        }

        .form-label {
          font-family: PingFang HK, PingFang HK;
          font-weight: 400;
          font-size: 14px;
          color: #000000;

          &.required {
            &:before {
              content: '*';
              margin-right: 5px;
              color: red;
            }
          }
        }

        .form-content {
          margin-top: 10px;

          textarea {
            padding: 10px;
            box-sizing: border-box;
            width: 100%;
            background: #FFFFFF;
            border-radius: 10px;
            border: 1px solid #F1F0F0;

            &::placeholder {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #A39992;
            }
          }

          .upload-box {
            height: 80px;
            background: #FFFFFF;
            border-radius: 10px;
            border: 1px solid #F1F0F0;
            display: flex;
            align-items: center;
            justify-content: center;

            .upload-icon {
              width: 40px;
              border: 1px dashed #F1F0F0;
            }
          }

          .van-uploader {
            width: 100%;

            /deep/ .van-uploader__input-wrapper {
              width: 100%;
            }

            /deep/ .van-uploader__preview {
              border: 1px solid #F1F0F0;
            }
          }
        }

        .tip,.tip1 {
          margin: 5px 0;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #A39992;
        }
        .tip1{
          font-weight: 900;
          color: #EB1700;
        }
      }

      .button-group {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        width: 100%;
        box-sizing: border-box;

        .confirm-btn {
          border-radius: 22px;
          font-size: 16px;
          font-weight: 500;
          width: 100%;
          height: 42px;
          background: #EB1700;
          font-family: PingFang SC, PingFang SC;
          color: #FFFFFF;
          cursor: pointer;
          border: none;
        }
      }
    }
  }

  .dailog-div {
    width: 100%;
    position: fixed;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;

    .dialog-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
    }

    .dialog-cons {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 300px;
      // border-radius: 10px;
      border-radius: 10px 10px 0 0;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      background: #fff;

      &.search {
        height: 420px;
      }

      .dialog-cons-bg {
        background-repeat: no-repeat;
        background-size: 100%;
        background-image: url("../../assets/images/regist/img7.png");
        width: 100%;
        height: 60px;
        position: absolute;
        top: 0;
        left: 0;
      }

      /deep/ .van-picker-column__item--selected {
        background: rgb(249, 248, 247);
      }

      .cons-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        padding: 0 20px;
        border-bottom: 1px solid #ebebeb;
        position: relative;
        background: #fff;
        border-radius: 10px 10px 0 0;

        .cancel-btn {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          cursor: pointer;
        }

        .title-txt {
          font-family: PingFang HK, PingFang HK;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }

        .confirm-btn {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #EB1700;
          cursor: pointer;
          width: 40px;
          text-align: right;
        }
      }

      .cons-search-hos {
        padding: 0 15px;
        box-sizing: border-box;
        margin-top: 10px;
        height: 350px;

        .search-hos-div {
          display: flex;
          align-items: center;
          height: 32px;
          border-radius: 100px;
          border: 1px solid #e3e3e3;
          padding-left: 10px;
          padding-right: 3px;
          box-sizing: border-box;

          .icon-search {
            width: 14px;
            display: block;
            margin-right: 5px;
          }

          input[type="search"] {
            font-family: PingFang HK, PingFang HK;
            font-size: 14px;
            color: #000000;
            border: none;
            outline: none;
            background-color: transparent;
            flex: 1;
            height: 100%;
          }

          .border-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 26px;
            border-radius: 25px;
            background: rgba(213, 207, 201, 0.5);
            cursor: pointer;

            .icon-search {
              width: 13px;
              display: block;
              margin-right: 4px;
            }

            .btn-txt {
              color: #000000;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 500;
              font-size: 13px;
            }
          }

        }

        .search-hos-list {
          overflow-y: auto;
          height: 310px;

          .search-hos-item {
            padding: 16px 0;
            box-sizing: border-box;
            border-bottom: 1px solid #e9e9e9;

            .item-name {
              font-family: PingFang HK, PingFang HK;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              margin-right: 10px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              line-height: 20px;
              margin-bottom: 4px;
            }

            .item-addr {
              font-family: PingFang HK, PingFang HK;
              font-weight: 400;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.6);
            }
          }

          .search-more {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #6a7481;
          }
        }
      }

      .cons-content {
        display: flex;
        flex-wrap: wrap;
        padding: 0 15px;
        box-sizing: border-box;
        margin-top: 10px;
        // height: 270px;
        overflow-y: auto;

        .cons-item {
          height: 35px;
          margin-bottom: 8px;
          font-family: PingFang HK, PingFang HK;
          font-weight: 400;
          font-size: 13px;
          color: #6a7481;
          border-radius: 8px;
          cursor: pointer;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background: rgb(249, 248, 247);
          margin-right: 7px;

          &.cur {
            border: 1px solid rgb(0, 0, 0);
            border-radius: 4px;
            color: #000;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/appealPage.vue